import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager } from "../../../../utils";

export const updateStaff = createAsyncThunk('updateStaff', async (data) => {

    var bodyFormData = new FormData()

    bodyFormData.append(
        "staff_id", data?.values?.id
    )
    bodyFormData.append(
        "staff_name", data?.values?.name
    )
    bodyFormData.append(
        "staff_code", data?.values?.staffId
    )
    bodyFormData.append(
        "staff_mobile", data?.values?.mobile
    )
    bodyFormData.append(
        "staff_email", data?.values?.email
    )
    bodyFormData.append(
        "department_id", data?.values?.department
    )
    bodyFormData.append(
        "designation_id", data?.values?.designation
    )
    bodyFormData.append(
        "role_id", data?.values?.role
    )
    bodyFormData.append(
        "status", data?.values?.status
    )
    {
        data?.values?.profilePhoto &&
            bodyFormData.append(
                "profile_photo", data?.values?.profilePhoto
            )
    }

    try {
        const res = await axios({

            method: 'POST',
            url: process.env.REACT_APP_API_URL + 'update_staff',
            data: bodyFormData,
            headers: { "Content-Type": "multipart/form-data", 'type': 'profile', "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})